<!-- The wordmark is a white-only PNG, so it has to sit on the deep green rather than on the card. -->
<div class="relative flex min-h-dvh flex-col items-center justify-center bg-primary-900 px-5 py-12">
  <!-- The website's wave motif as a waterline. Same shape as frontend/src/assets/img/wave-up-1000.svg,
       inlined so the greens come from the theme palette instead of the file's baked-in hex values. -->
  <div aria-hidden="true" class="pointer-events-none absolute inset-x-0 bottom-0">
    <svg class="block h-14 w-full sm:h-24" viewBox="0 0 1000 64" preserveAspectRatio="none">
      <path class="fill-primary-700" d="M-39.1249801,12.0215973 C80.8175127,42.8057393 329.274689,46.458236 420.065224,30.4008746 C598.557537,-1.1675659 803.878356,0.391935162 1036.02768,35.0793778 L1036.02768,76.5161523 L-39.1249801,76.5161523 C-119.086642,12.9970209 -119.086642,-8.50116409 -39.1249801,12.0215973 Z" />
      <path class="fill-primary-950" d="M-83,30.1682247 C117.12518,43.7914066 295.559023,40.783114 452.301527,21.1433471 C609.044031,1.50358016 803.943522,10.3840178 1037,47.7846599 L1037,89 L-83,89 L-83,30.1682247 Z" />
    </svg>
    <div class="h-8 bg-primary-950 sm:h-14"></div>
  </div>

  <div class="relative w-full max-w-md">
    <div class="mb-8 flex flex-col items-center text-center">
      <img src="logo/brand.png"
           srcset="logo/brand.png 1x, logo/brand@2x.png 2x"
           width="150"
           height="94"
           class="h-24 w-auto sm:h-28"
           [alt]="'login.title' | translate">
      <h1 class="m-0 mt-6 text-2xl font-medium text-white">{{ 'login.subtitle' | translate }}</h1>
    </div>

    <mat-card class="rounded-2xl p-6 shadow-2xl sm:p-8">
      <mat-card-content>
        <!-- Login Form -->
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
          <!-- Username Field -->
          <mat-form-field class="w-full">
            <mat-label>{{ 'login.email-label' | translate }}</mat-label>
            <input matInput
                   type="email"
                   formControlName="username"
                   [placeholder]="'login.email-placeholder' | translate"
                   autocomplete="username">
            <mat-icon matSuffix>person</mat-icon>
            @if (loginForm.hasError('required', 'username')) {
              <mat-error>{{ 'login.email-required' | translate }}</mat-error>
            }
            @if (loginForm.hasError('email', 'username')) {
              <mat-error>{{ 'login.email-invalid' | translate }}</mat-error>
            }
          </mat-form-field>

          <!-- Password Field -->
          <mat-form-field class="w-full">
            <mat-label>{{ 'login.password-label' | translate }}</mat-label>
            <input matInput
                   [type]="hidePassword ? 'password' : 'text'"
                   formControlName="password"
                   [placeholder]="'login.password-placeholder' | translate"
                   autocomplete="current-password">
            <button matIconButton
                    matSuffix
                    (click)="togglePasswordVisibility()"
                    [attr.aria-label]="'login.hide-password' | translate"
                    [attr.aria-pressed]="hidePassword"
                    type="button">
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (loginForm.hasError('required', 'password')) {
              <mat-error>{{ 'login.password-required' | translate }}</mat-error>
            }
          </mat-form-field>

          <!-- Login Button -->
          <button matButton="filled"
                  type="submit"
                  class="sign-in-button mt-2 w-full text-base font-medium"
                  [disabled]="isLoading()">

            @if (isLoading()) {
              <mat-spinner diameter="20" />
            } @else {
              <mat-icon>login</mat-icon>
            }
            {{ isLoading() ? ('login.signing-in' | translate) : ('login.sign-in' | translate) }}
          </button>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
